import { useContext } from 'react'
import { Link } from 'react-router'
import { Tooltip, Typography } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid-pro'

import { AppContext } from '../../../../providers/app-provider'
import { getVanityName } from '../../../../utils/helpers'
import useSharedStyles from '../../../../utils/shared.styles'

const AlertsTableDevice = (cellParams: GridCellParams<AccountAlertTableRow, AccountAlertTableRow['deviceInfo']>) => {
  const { tenantId } = useContext(AppContext)
  const classes = useSharedStyles
  const cellValue = cellParams.value

  if (!cellValue) return <></>

  return (
    <div style={classes.fullWidth}>
      <Tooltip
        title={
          <>
            {getVanityName(cellValue.deviceName)}
            <br />
            {cellValue.deviceLocation}
          </>
        }
      >
        <Typography variant="body2" sx={classes.overflowText}>
          <Link to={`/tenant/${tenantId}/devices/${cellValue.deviceId}`} style={classes.overflowText}>
            {getVanityName(cellValue.deviceName)}
          </Link>
          <br />
          {cellValue.deviceLocation}
        </Typography>
      </Tooltip>
    </div>
  )
}

export default AlertsTableDevice
